import { DeleteRoleApiResponse } from './../../models/delete-role-api-response.model';
import { AdminRolesDetailComponent } from './../admin-roles-detail/admin-roles-detail.component';
import { RolesService } from './../../services/roles.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { RolesDataSource } from '../../datasources/roles-data-source';
import { SelectionModel } from '@angular/cdk/collections';
import { Role } from '../../models/role.model';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-admin-roles',
  templateUrl: './admin-roles.component.html',
  styleUrls: ['./admin-roles.component.scss']
})
export class AdminRolesComponent implements OnInit, AfterViewInit {
  dataSource: RolesDataSource;
  displayedColumns = ['roleName', 'status', 'updatedBy', 'updated', 'actions'];

  selection = new SelectionModel<Role>(true, []);
  viewOnlyActive = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private rolesService: RolesService, public dialog: MatDialog) {}

  ngOnInit() {
    this.dataSource = new RolesDataSource(this.rolesService);
    this.dataSource.loadRoles(null, null, null, true);
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadRoles();
    });
    this.paginator.page.pipe(tap(() => this.loadRoles())).subscribe();
  }

  loadRoles() {
    this.dataSource.loadRoles(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      (this.sort.direction === 'desc' ? '-' : '') + this.sort.active,
      this.viewOnlyActive
    );
  }

  changeOnlyActive() {
    this.viewOnlyActive = !this.viewOnlyActive;
    this.loadRoles();
  }

  editRole(role: Role) {
    const dialogRef = this.dialog.open(AdminRolesDetailComponent, {
      width: '',
      data: { roleInfo: role },
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadRoles();
    });
  }

  toggleRole(role: Role) {
    this.rolesService.toggleRoleStatus(role.roleName).subscribe(data => {
      if (data.success) {
        if (role.status === 'A') {
          role.status = 'D';
        } else {
          role.status = 'A';
        }
      }
    });
  }
  // restoreRole(role: Role) {
  //   role.status = 'A';
  // }
}
